import { FlexibleReportsBuilder } from './FlexibleReportsBuilder'

export function FlexibleReportsPage() {
  return <FlexibleReportsBuilder standalone />
}
